/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationResponseBaseResponse as ModelsV4ApplicationApplicationResponseBaseResponse } from '../../models/Models/v4/Application/application-response-base-response';
import { ApplicationStartRequest as ModelsV4ApplicationApplicationStartRequest } from '../../models/Models/v4/Application/application-start-request';

export interface V4ApplicationPersonalloanPost$Json$Xml$Params {
      body?: ModelsV4ApplicationApplicationStartRequest
}

export function v4ApplicationPersonalloanPost$Json$Xml(http: HttpClient, rootUrl: string, params?: V4ApplicationPersonalloanPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationPersonalloanPost$Json$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>;
    })
  );
}

v4ApplicationPersonalloanPost$Json$Xml.PATH = '/v4/application/personalloan';
